/* eslint-disable @typescript-eslint/no-unused-vars */
import { Component, ComponentTuple, component } from '../../../concepts/objects';
import { Matrix, MatrixTransformable } from '../../../platform/geom/Matrix';
import { Point } from '../../../platform/geom/Point';
import { Rect } from '../../../platform/geom/Rect';
import { Figure, GuideLine, Physical, PotentialInteraction, RelativeTo, TransformAction, TransformHints, TransformScope } from './Physical';
import { UIField } from './UIField';

const rootDef = {
    name: 'root',
    implements: [Physical],
};

@component(rootDef)
export class Root extends Component implements Physical {

    public readonly boundary: boolean = false;

    public readonly width: number = 0;

    public readonly height: number = 0;

    public readonly name = 'Root';

    public x: number = 0;

    public y: number = 0;

    public r: number = 0;

    public anchor: number = 0;

    public locked: boolean = false;

    public parentPhysical: Physical = null;

    public uiFields: readonly UIField[] = [];

    public bounded(): boolean {
        return false;
    }

    public mounted() {
        return true;
    }

    public queryGuides(): GuideLine[] {
        return [];
    }

    public queryTransformActions(singular: boolean): TransformAction[] {
        return [];
    }

    public queryTransformHints(singular: boolean): TransformHints {
        return TransformHints.off;
    }

    public applyTransformation(scope: TransformScope, from: Figure, to: Figure): this {
        return this;
    }

    public createFigure(): Figure {
        // Not supported
        return [Point.zero, Point.zero, Point.zero, Point.zero];
    }

    public setFromFigure(figure: Figure): void {
        // Not supported
    }

    public moveTo(..._input: any[]): this {
        return this;
    }

    public moveBy(..._input: any[]): this {
        return this;
    }

    public rotateTo(..._input: any[]): this {
        return this;
    }

    public rotateBy(..._input: any[]): this {
        return this;
    }

    public transform = () => Matrix.identity;

    public area = () => Rect.empty;

    public bounds = () => Rect.empty;

    public position = () => Point.zero;

    public center = () => Point.zero;

    public rotation = () => 0;

    public size = () => Point.zero;

    public outline = () => { throw new Error('Root does not support path() method.'); };

    public path = () => { throw new Error('Root does not support outline() method.'); };

    public test(_mpt: Point): boolean {
        return true;
    }

    public testInteraction(_pi: PotentialInteraction, _force?: boolean, _selected?: boolean): [boolean, string] {
        return [false, 'none'];
    }

    public toRelative(mpt: Point): Point;
    public toRelative(mpts: readonly Point[]): Point[];
    public toRelative<T>(mg: MatrixTransformable<T>): T;
    public toRelative(input: any): any {
        return input;
    }

    public toEmptyTuple(to?: Physical | RelativeTo): ComponentTuple {
        return this.toShallowTuple();
    }
}
